import { Questionnaire } from '../../types';

export const createEmptyQuestionnaire = (): Questionnaire => ({
  title: '',
  sections: [{ section: 0, questions: [] }]
});
